/*
 * Helper to consolidate the logic needed
 * for the filtering functionality in the
 * Dashboard TableContainer files.
 *
 */

import { isArray, isEmpty, isNil } from 'lodash';

export const renderChip = filters => {
    let formattedFilters = [];

    if (filters.type && isArray(filters.type)) {
        formattedFilters = [...filters.type.map(type => type.name)];
    }

    if (filters.status && isArray(filters.status) && !isEmpty(filters.status)) {
        formattedFilters.push(...filters.status);
    }

    if (filters.priority.high) {
        formattedFilters.push('High');
    }

    if (filters.priority.medium) {
        formattedFilters.push('Medium');
    }

    if (filters.priority.low) {
        formattedFilters.push('Low');
    }
    
    return formattedFilters;
};

export const renderFilter = filters => {
    if (isEmpty(filters)) {
        filters.type = [];
        filters.priority = {
            high:   false,
            medium: false,
            low:    false
        };
        filters.status = [];
    }

    return filters;
};

export const removeFilter = (setFilters, filters, item) => {
    if (item === 'High') {
        filters.priority.high = false;
    } else if (item === 'Medium') {
        filters.priority.medium = false;
    } else if (item === 'Low') {
        filters.priority.low = false;
    } else {
        const index = filters.type.map(filter => filter.name).indexOf(item) >= 0 ? filters.type.map(filter => filter.name).indexOf(item) : null;
        const statusIndex = filters.status.map(filter => filter).indexOf(item) >= 0 ? filters.status.map(filter => filter).indexOf(item) : null;

        if (!isNil(index)) {
            filters.type.splice(index, 1);
        }

        if (!isNil(statusIndex)) {
            filters.status.splice(statusIndex, 1);
        }
    }

    setFilters(filters);
};
